export default __webpack_public_path__ + "static/media/36I-114277_-20866_0.be8f9878.jpg";